import { readStorageItem } from "../../Api/Utils/apiUtils"
import { POPUP_ACTIVE, POPUP_DEACTIVE, POPUP_NAME } from "../Const/const"



const popupReducer = (state = { isUserSaw: readStorageItem(POPUP_NAME) === 'true' ? 'true': readStorageItem(POPUP_NAME) === 'false' ? 'false' : 'false' }, action) => {
    switch (action.type) {
        case POPUP_ACTIVE:
            const active = readStorageItem(POPUP_NAME) 
            return { isUserSaw: active }
        case POPUP_DEACTIVE:
            const deactive = readStorageItem(POPUP_NAME)
            return { isUserSaw: deactive }
        default:
            return state;
    }
}
export default popupReducer;